/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { getApiUrl } from 'utils/location'
import { getMockDataKey } from 'utils/mocks'

const handleError = (response) => {
  const { status = 500, statusText, body } = response
  const error: any = new Error(body || statusText)
  error.status = status
  error.statusText = statusText
  error.result = body
  throw error
}

const fetchBlob = (requestUrl, requestOptions) => {

  var fileName = '';

  return fetch(requestUrl, requestOptions)
    .then(response => {
      if (response.ok) {

        fileName = response.headers.get('Content-Disposition');
        return  response.blob();
      }

      const { status, statusText, ok } = response
      const bodyPromise = response.json()
      return bodyPromise.then(body => ({ status, statusText, ok, body }))
    })
    .then(blob => {
      if (blob.ok !== undefined && !blob.ok) {
        return handleError(blob)
      }

      return {
        value : blob,
        fileName : fileName
      }
    })
}

export default (apiAction, meta: any = {}, { type }) => {
  const {
    method,
    url, // NOTE: must have a leading slash
    query,
    data,
    headers,
    parseResponse,
    hostname,
  } = apiAction

  const requestOptions: any = {
    method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      ...headers,
    },
  }

  const methodUpperCase = method.toUpperCase()
  if (data && (methodUpperCase === 'POST' || methodUpperCase === 'PUT' || methodUpperCase === 'PATCH')) {
    if (meta && meta.sendFormData) {
      requestOptions.body = data
    } else {
      requestOptions.headers['Content-Type'] = 'application/json'
      requestOptions.body = typeof data !== 'string' ? JSON.stringify(data) : data
    }
  }

  const requestUrl = getApiUrl({ pathname: url, query, hostname })

  if (meta && meta.getBlob) {
    return fetchBlob(requestUrl, requestOptions)
  }

  const fetchPromise = __USE_MOCK__ && meta.mock
    ? require('./mocks/').mockedFetch(requestUrl, requestOptions)
    : fetch(requestUrl, requestOptions)

  return fetchPromise
    .then(response => {
      const { status, statusText, ok, isMock } = response

      let bodyPromise

      if (status === 204) {
        // note: no content status
        bodyPromise = Promise.resolve(null)
      } else if (
        response.headers.get('Content-Length') !== '0' &&
        response.headers.get('Content-Type') &&
        response.headers.get('Content-Type').includes('application/json')
      ) {
        bodyPromise = response.json()
      } else {
        bodyPromise = Promise.resolve({})
      }

      return bodyPromise.then(body => ({ status, statusText, ok, body, isMock }))
    })
    .then(response => {
      if (__USE_MOCK__ && !response.isMock && response.ok && meta.mock) {
        const key = getMockDataKey(requestUrl, requestOptions)

        fetch('/mocks', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ key, data: response.body }),
        })
      }
      if (!response.ok) {
        return handleError(response)
      }

      return response
    })
    .then(response => {
      const { status, body } = response
      const result = body

      let parsedResponseBody = { result }

      if (parseResponse) {
        parsedResponseBody = parseResponse(parsedResponseBody, response, meta)
      }

      return { ...parsedResponseBody, status }
    })
    .catch((error: Error) => {
      throw error
    })
}
